import React from 'react'
import { Switch, useRouteMatch, useParams } from 'react-router-dom'
import { SecureRoute } from '@okta/okta-react'
import DenaliActionProvider from '../../../../components/organisms/DenaliActionPipeline/provider/DenaliActionProvider'
import NotFoundView from '../common/NotFoundView'
import MeetingsHome from './Home'
import MeetingDetail from './MeetingDetail'
import MeetingActionDialog from './MeetingActionDialog'

function MeetingDetailRoute () {
  const { meetingId } = useParams()
  return <MeetingDetail key={meetingId} />
}

function Meetings () {
  const { path } = useRouteMatch()

  return (
    <DenaliActionProvider>
      <Switch>
        <SecureRoute path={`${path}`} exact>
          <MeetingsHome />
        </SecureRoute>
        <SecureRoute path={`${path}/:meetingId`} exact>
          <MeetingDetailRoute />
        </SecureRoute>
        <SecureRoute path='*'>
          <NotFoundView />
        </SecureRoute>
      </Switch>
      <MeetingActionDialog />
    </DenaliActionProvider>
  )
}

export default Meetings
